import alan from '../assets/team/alan.jpg';
import felipe from '../assets/team/felipe.jpg';
import roberto from '../assets/team/roberto.jpg';
import manfred from '../assets/team/manfred.jpg';
import david from '../assets/team/david.jpg';
import francisco from '../assets/team/francisco.jpg';

// Team Member Data with Translations
export const teamTranslations = {
    es: {
        title: "Equipo Directivo",
        members: [
            {
                name: 'Alan Nudman',
                role: 'CEO & Founder',
                image: alan,
                linkedin: 'https://www.linkedin.com/in/alannudman/'
            },
            {
                name: 'Felipe Frias',
                role: 'CFO',
                image: felipe,
                linkedin: 'https://www.linkedin.com/in/felipe-frias-uribe/'
            },
            {
                name: 'Roberto Roizman',
                role: 'Cofounder',
                image: roberto,
                linkedin: 'https://www.linkedin.com/in/roberto-roizman-leyde-5472005/'
            },
            {
                name: 'Manfred Koenig',
                role: 'CRO',
                image: manfred,
                linkedin: 'https://www.linkedin.com/in/manfred-koenig-r/'
            },
            {
                name: 'Md. David Kohn',
                role: 'Cofounder',
                image: david,
                linkedin: 'https://www.linkedin.com/in/david-kohn-74a03b95/'
            },
            {
                name: 'Francisco Balart',
                role: 'Cofounder',
                image: francisco,
                linkedin: 'https://www.linkedin.com/in/franciscobalart/'
            }
        ]
    },
    en: {
        title: "Executive Team",
        members: [
            {
                name: 'Alan Nudman',
                role: 'CEO & Founder',
                image: alan,
                linkedin: 'https://www.linkedin.com/in/alannudman/'
            },
            {
                name: 'Felipe Frias',
                role: 'CFO',
                image: felipe,
                linkedin: 'https://www.linkedin.com/in/felipe-frias-uribe/'
            },
            {
                name: 'Roberto Roizman',
                role: 'Cofounder',
                image: roberto,
                linkedin: 'https://www.linkedin.com/in/roberto-roizman-leyde-5472005/'
            },
            {
                name: 'Manfred Koenig',
                role: 'CRO',
                image: manfred,
                linkedin: 'https://www.linkedin.com/in/manfred-koenig-r/'
            },
            {
                name: 'Md. David Kohn',
                role: 'Cofounder',
                image: david,
                linkedin: 'https://www.linkedin.com/in/david-kohn-74a03b95/'
            },
            {
                name: 'Francisco Balart',
                role: 'Cofounder',
                image: francisco,
                linkedin: 'https://www.linkedin.com/in/franciscobalart/'
            }
        ]
    }
};
